// state
export const state = {
    currentSummary: null
}

// getters
export const getters = {
    currentSummary: state => state.currentSummary
}

// mutations
export const mutations = {
    setSummary: (state, currentSummary) => {
        state.currentSummary = currentSummary
    }
}

// actions
export const actions = {

}